import React from 'react'
import { Formik, Field, Form } from "formik";
import { FaArrowRight, FaEnvelope, FaShieldAlt, FaUser } from 'react-icons/fa';


export const Signup = () => {
  //  require('scss/ui/login.scss')

   return  (
            <>
            { <React.Fragment>
                <Formik
                    initialValues={{  name:'', email: "test@test.com", password:"123123" /* first:"", last:"" */ }} 
                    onSubmit={async values => {
                        //alert(JSON.stringify(values))
                       //@ts-ignore
                    }}
                >
                    <Form>
                        <div className="signin_component">
                            <div className="forwarding">
                            <div className="logo">
                                    NOVA {/** <img src="/logo/logo.png" height="40" alt="" /> **/}
                                </div>
                                <a href="/signin"   className="goto">
                                         <FaArrowRight size={255} />
                                         Create one
                                 </a>
                                
                            </div>
                            
                            <div className="col-md-4 offset-md-4 sign pl-5 pt-3 p-3">
                                <div className="">
                                    <h1 className="text-center">Sign up</h1>
                                    <p className="text-center">Hi, We're so excited to have you between us!</p>
                                
                                    <div className="form-group">
                                        <div className="input">
                                            <Field type="text" name="name" placeholder="Username" className="form-control" />
                                            <FaUser />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="input">
                                            <Field type="text" name="email" placeholder="example@example.com" className="form-control" />
                                            <FaEnvelope />
                                        </div>
                                    </div>
                
                                    <div className="form-group">
                                        <div className="input">
                                            <Field type="password" name="password" placeholder="*****" className="form-control" />
                                            <FaShieldAlt />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="input">
                                            <Field type="password" name="confirm" placeholder="*****" className="form-control" />
                                            <FaShieldAlt />
                                        </div>
                                    </div>

                                    <div className="form-group go">

                                        <a href="/account" className="btn btn-primary ">
                                            <button>Sign up</button>
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <a href="/forgotten" className="text-center soft"><p>Forgotten</p></a>
                                 </div>
                            </div>
                        </div>	
                    </Form>

                </Formik>
            </React.Fragment> }
           </>
        );
}
 
export default Signup;
